<template>
  <div class="container px-0">
    <div class="row mb-2">
      <!-- <div class="col-8">
        <h2 class="typo-h5 ">New Video</h2>
      </div>
      <div class="col-4">
        <h2 class="typo-h5 ">Recommended</h2>
      </div>-->

      <!-- <div class="col-12 typo-h5 flex-v-center breadcrumb">
        <router-link class="rl" :to="{ name: 'Tutorials' }">Tutorials</router-link>
        
        <i class="icon icon-arrow-right"></i>
        <router-link class="rl" :to="{ name: 'Tutorials' }">Topics</router-link>
      </div> -->
    </div>
    <div class="bb1sg"></div>
    <div class="row">
      <template v-if="topic.fetched">
        <template v-if="topic.list.length">
          <TopicItem :item="topic" v-for="(topic, ind) in topic.list" :key="ind" />
        </template>
        <template v-else>
          <GpEmptyPage page="videoTutorial" />
        </template>
      </template>
      <template v-else>
        <TopicItem v-for="ind in 6" :key="ind" />
      </template>
    </div>
  </div>
</template>

<script>
import { TopicItem } from "../components";
import { mapState } from "vuex";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
export default {
  name: "TutorialTopics",
  components: {
    TopicItem,
    GpEmptyPage
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      allTopics: state => state.tutorial.topics,
      topic: state => state.tutorial.topic
    }),
    topics() {
      if (!this.allTopics) return [];
      return this.allTopics.map(item => {
        item.title = this.$t(item.title);
        item.describes = this.$t(item.describes);
        return item;
      });
    }
  },
  methods: {
    onTabChangeHandler() {}
  }
};
</script>

<style lang="scss" scoped>

.bb1sg {
  border-bottom: 1px solid $grey3;
}
</style>
